import React from "react";
import "../css/header.css";
import AlmaEconomicsLogo from "../images/almaeconomics_logo.svg";
import SocialCareWalesLogo from "../images/socialcarewales_logo.svg";
import { useNavigate } from "react-router-dom";

const Header = () => {
	let navigate = useNavigate();
	return (
		<div>
			<div>
				<header className="header-container">
					<div>
						<div className="header-left-section">
							<a
								href="https://socialcare.wales"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src={SocialCareWalesLogo}
									alt="Social Care Wales Logo"
								/>
							</a>
						</div>
						<div
							className="header-middle-section"
							onClick={() =>
								window.location.pathname !== "/" &&
								navigate("/")
							}
						>
							<h1>Mathematical Modelling</h1>
						</div>
						<div className="header-right-section">
							<a
								href="https://www.almaeconomics.com/"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src={AlmaEconomicsLogo}
									alt="Alma Economics Logo"
								/>
							</a>
						</div>
					</div>
				</header>
				<header className="header-container-mobile">
					<div
						className="header-middle-section"
						onClick={() =>
							window.location.pathname !== "/" && navigate("/")
						}
					>
						<h1>Mathematical Modelling</h1>
					</div>
					<div className="header-logo-section">
						<div className="header-left-section">
							<a
								href="https://socialcare.wales"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src={SocialCareWalesLogo}
									alt="Social Care Wales Logo"
								/>
							</a>
						</div>

						<div className="header-right-section">
							<a
								href="https://www.almaeconomics.com/"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src={AlmaEconomicsLogo}
									alt="Alma Economics Logo"
								/>
							</a>
						</div>
					</div>
				</header>
			</div>
			<div className="header-navbar">
				<div className="home-button-containter">
					<button
						className={
							window.location.pathname === "/" ? "selected" : ""
						}
						onClick={() =>
							window.location.pathname !== "/" && navigate("/")
						}
					>
						Home
					</button>
				</div>
				<div className="outputs-button-container">
					<button
						className={
							window.location.pathname === "/scenario-analysis"
								? "selected"
								: ""
						}
						onClick={() =>
							window.location.pathname !== "/scenario-analysis" &&
							navigate("/scenario-analysis")
						}
					>
						Scenario Analysis
					</button>
					<button
						className={
							window.location.pathname === "/risk-factor-analysis"
								? "selected"
								: ""
						}
						onClick={() =>
							window.location.pathname !==
								"/risk-factor-analysis" &&
							navigate("/risk-factor-analysis")
						}
					>
						Risk Factor Analysis
					</button>
					<button
						className={
							window.location.pathname === "/benchmarking"
								? "selected"
								: ""
						}
						onClick={() =>
							window.location.pathname !== "/benchmarking" &&
							navigate("/benchmarking")
						}
					>
						Benchmarking
					</button>
					<button
						className={
							window.location.pathname ===
							"/time-series-forecasting"
								? "selected"
								: ""
						}
						onClick={() =>
							window.location.pathname !==
								"/time-series-forecasting" &&
							navigate("/time-series-forecasting")
						}
					>
						Time Series Forecasting
					</button>
				</div>
			</div>
		</div>
	);
};

export default Header;
